import { Box, Divider, styled } from '@mui/material';

const HEADER_HEIGHT_PX = 64;
const SECTION_GAP_PX = 16;
const PANEL_TOP_OFFSET_PX = 65;

export const ManagementContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'stretch',
  margin: theme.spacing(-3),
  minHeight: `calc(100vh - ${HEADER_HEIGHT_PX}px)`,
  padding: `${SECTION_GAP_PX}px 0 0 ${SECTION_GAP_PX}px`,
  backgroundColor: theme.palette.background.default,
}));

export const ManagementContent = styled(Box)({
  flex: 1,
  minWidth: 0,
  display: 'flex',
  flexDirection: 'column',
  padding: `0 50px 0 ${SECTION_GAP_PX}px`,
});

export const ManagementBreadcrumbsRow = styled(Box)({
  display: 'flex',
  alignItems: 'flex-end',
  height: `${PANEL_TOP_OFFSET_PX - SECTION_GAP_PX}px`,
  minWidth: 0,
  padding: '0 0 16px 4px',
});

export const ManagementPanel = styled(Box)(({ theme }) => ({
  minWidth: 0,
  marginBottom: '24px',
  backgroundColor: theme.palette.common.white,
  borderRadius: '4px',
  boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.03)',
}));

export const ManagementFlatPanel = styled(ManagementPanel)({
  boxShadow: 'none',
});

const SECTION_CONTENT_GAP_PX = 16;
const HORIZONTAL_INSET_PX = 24;
const TITLE_TOP_PX = 21;
const TITLE_LINE_HEIGHT_PX = 20;
const TITLE_TO_DIVIDER_PX = 20;
const DIVIDER_TO_CONTENT_PX = 32;
const TAB_LABEL_INSET_PX = 16;

export const ManagementSectionContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: `${SECTION_CONTENT_GAP_PX}px`,
  height: '100%',
}));

export const ManagementSectionTitle = styled('h1')(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  fontSize: '20px',
  fontWeight: 600,
  lineHeight: `${TITLE_LINE_HEIGHT_PX}px`,
  color: theme.palette.secondary.contrastText,
  margin: 0,
  padding: `${TITLE_TOP_PX}px 0 0 ${HORIZONTAL_INSET_PX}px`,
}));

export const ManagementSectionHeader = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  gap: '16px',
  paddingRight: `${HORIZONTAL_INSET_PX}px`,
}));

export const ManagementSectionActions = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  alignSelf: 'flex-end',
  gap: '8px',
  height: `${TITLE_LINE_HEIGHT_PX}px`,
}));

export const ManagementSectionDivider = styled(Divider)(({ theme }) => ({
  borderColor: theme.palette.info.main,
  margin: `${TITLE_TO_DIVIDER_PX - SECTION_CONTENT_GAP_PX}px 0 0`,
}));

export const ManagementSectionBody = styled(Box, {
  shouldForwardProp: prop => prop !== 'hasTabs',
})<{ hasTabs?: boolean }>(({ hasTabs }) => ({
  padding: `0 ${HORIZONTAL_INSET_PX}px ${HORIZONTAL_INSET_PX}px`,
  paddingTop: `${DIVIDER_TO_CONTENT_PX - SECTION_CONTENT_GAP_PX - (hasTabs ? TAB_LABEL_INSET_PX : 0)}px`,
}));
